jQuery(function ($, undefined) {
  //uses classList, setAttribute, and querySelectorAll
  //if you want this to work in IE8/9 youll need to polyfill these
  var d = document,
      accordionToggles = d.querySelectorAll('.js-accordion__title'),
      setAria,
      setAccordionAria,
      switchAccordion,
      touchSupported = ('ontouchstart' in window),
      pointerSupported = ('pointerdown' in window);
  
  // For IE8/9
  var prevElementSibling = (function() {
    var supported = !!document.body.previousElementSibling,
        prev = (supported) ? 'previousElementSibling' : 'previousSibling';
  
    return function(currentElement) {
      return currentElement[prev];
    };
  }());
 
  var nextElementSibling = (function() {
    var supported = !!document.getElementsByTagName('head')[0].nextElementSibling,
      next = (supported) ? 'nextElementSibling' : 'nextSibling';
    
    return function(currentElement) {
      return currentElement[next];
    };
  }());
  
  
  skipClickDelay = function(e) {
    e.preventDefault();
    e.target.click();
  }

  setAriaAttr = function(el, ariaType, newProperty) {
    el.setAttribute(ariaType, newProperty);
  }
  
  setAccordionAria = function(el1, el2, expanded) {
    switch(expanded) {
      case "true":
        setAriaAttr(el1, 'aria-expanded', 'true');
        setAriaAttr(el2, 'aria-hidden', 'false');
        break;
   
      case "false":
        setAriaAttr(el1, 'aria-expanded', 'false');
        setAriaAttr(el2, 'aria-hidden', 'true');
        break;
      
      default:
        break;
    }
  }
  
  //function
  switchAccordion = function(e) {
    e.preventDefault();

    if(e.target.classList.contains('fa-calendar')) {
      // Stupid IE8
      if($('html').hasClass('lt-ie9')) {
        var addToCalendarHeader = nextElementSibling(e.target.parentNode.parentNode).childNodes[0];
      } else {
        var addToCalendarHeader = nextElementSibling(e.target.parentNode.parentNode).childNodes[1];
      }
    } else {
      if(e.target.classList.contains('accordion__title--desktop')) {
        var addToCalendarHeader = nextElementSibling(e.target);
      } else {
        // Stupid IE8
        if($('html').hasClass('lt-ie9')) {
          var addToCalendarHeader = nextElementSibling(e.target.parentNode).childNodes[0];
        } else {
          var addToCalendarHeader = nextElementSibling(e.target.parentNode).childNodes[1];

        }
      }
    }
    
    var addToCalendarButtons = e.target;
    
    if(addToCalendarHeader.classList.contains('is-collapsed')) {
      setAccordionAria(addToCalendarButtons, addToCalendarHeader, 'true');
    } else {
      setAccordionAria(addToCalendarButtons, addToCalendarHeader, 'false');
    }
    
    addToCalendarButtons.classList.toggle('is-collapsed');
    addToCalendarButtons.classList.toggle('is-expanded');
    addToCalendarHeader.classList.toggle('is-collapsed');
    addToCalendarHeader.classList.toggle('is-expanded');
    addToCalendarHeader.classList.toggle('animate-in');
  }
  
  for (var i=0, len=accordionToggles.length; i<len; i++) {
    if(touchSupported) {
      accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
    }
 
    if(pointerSupported) {
      accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
    }
 
    accordionToggles[i].addEventListener('click', switchAccordion, false);
  }
});

